import ResourceType from "../../datatype/ResourceType";

class AttachmentListCell {
    constructor(url = "", name = ""){
        this.name = name;
        this.url = url;
        this.size = 0;
        this.nodeId = -1;
        this.nodeText = "";
        this.type = ResourceType.WORD;
    }
}

export default AttachmentListCell